import { defineStore } from 'pinia'

export const useDeviceStore = defineStore({
  id: 'device',
  state: () => ({
    currentMode: 'COMPUTER'
  }),
  getters: {
    
  },
  actions: {
    changeMode(mode) {
      this.currentMode = mode
    }
  }
})
